<template>
  <div>
    <div class="py-3 bg-white text-center">ไม่มีข้อมูล</div>
  </div>
</template>

<script>
export default {
  name: "App",
  data() {
    return {};
  },
  methods: {},
  computed: {},
  watch: {},
  components: {},
};
</script>

<style></style>
